// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 653 ? "locale-[request]" : chunkId) + "-legacy." + {"129":"71c62729","244":"7cf207dc","427":"b2289cdb","569":"3421f22e","653":"59885ba5","674":"69a65ec3","686":"d1b296c0","777":"11055b71","799":"cd9c03f7","863":"844e592d"}[chunkId] + ".js";
};